<template>
  <div class="my-collect">
    <div class="cons-flex">
      <div class="cons-item" @click="handleClick(0)" :class="curItem === 0 ? 'cur' : ''">
        课程
        <img v-if="curItem === 0" src="@/assets/images/home/underline@2x.png" class="img-btm" alt="">
      </div>
      <div class="cons-item" @click="handleClick(1)" :class="curItem === 1 ? 'cur' : ''">
        病例
        <img v-if="curItem === 1" src="@/assets/images/home/underline@2x.png" class="img-btm" alt="">
      </div>
      <div class="cons-item" @click="handleClick(2)" :class="curItem === 2 ? 'cur' : ''">
        文章
        <img v-if="curItem === 2" src="@/assets/images/home/underline@2x.png" class="img-btm" alt="">
      </div>
      <div class="cons-item" @click="handleClick(3)" :class="curItem === 3 ? 'cur' : ''">
        直播
        <img v-if="curItem === 3" src="@/assets/images/home/underline@2x.png" class="img-btm" alt="">
      </div>
      <div class="cons-item" @click="handleClick(4)" :class="curItem === 4 ? 'cur' : ''">
        其他
        <img v-if="curItem === 4" src="@/assets/images/home/underline@2x.png" class="img-btm" alt="">
      </div>
    </div>
    <van-list v-model="loading" v-if="list.length > 0 && !isNone" :finished="finished" finished-text="我是有底线的" loading-text="正在加载..." @load="onLoad" class="cons-list">
      <div class="flex-con" v-for="(item, index) in list" :key="index" @click="handleJump(item)" v-track="{ functionName: '个人中心-内容收藏列表' }">
        <div class="left-con">
          <div class="txt1">{{ item && item.title }}</div>
          <div class="txt2">
            <span class="span1" v-if="item.author">讲师：{{ item && item.author }}</span>
            <div class="item-unlock" v-if="`${item.isUnlock}` === '1' && !item.myUnlock">
              <img src="@/assets/images/data-base/unlock.png" class="icon-unlock" alt="">
              <span class="txt">{{ item && item.unlockCost }}积分解锁</span>
            </div>
            <span v-if="curItem === 0" class="span2">播放量:{{ item && item.count }}</span>
            <span v-if="curItem === 4 && item.baseType !== 9" class="span2">阅读量:{{ item && item.count }}</span>
          </div>
        </div>
        <div class="right-con">
          <img :src="item && item.coverUrl" class="con-cover" alt="">
        </div>
      </div>
    </van-list>
    <div class="search-none" v-else-if="list.length <= 0 && isNone">
      <img src="@/assets/images/home/empty_state_none@2x.png" class="none-img" alt="">
      <div class="none-txt">暂无内容</div>
    </div>
  </div>
</template>
<script>
import { userMyCollect, liveCollect, docuCollect, caseCollect } from '@/api/person'
import { setSha, traceClickURL } from '@/utils/util'
import withRouteTracking from '@/utils/withRouteTracking'
import {isScorm} from '../../api/scorm'
const UserProfile = {
  name: 'myCollect',
  data() {
    return {
      curItem: 0,
      list: [],
      loading: false,
      finished: false,
      pageNum: 1,
      pageSize: 10,
      load: false,
      isNone: false,
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  mounted() {
    this.onLoad()
  },
  methods: {
    handleClick(index) {
      this.curItem = index
      this.pageNum = 1
      this.finished = false
      this.load = false
      this.list = []
      this.onLoad()
    },
    onLoad () {
      if (this.load) {
        return
      }
      this.load = true
      let params = {
        userId: this.userInfo.id,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      if (`${this.curItem}` === '0') {
        params.baseType = 1
      } else if (`${this.curItem}` === '2') {
        params.baseType = 6
      } else if (`${this.curItem}` === '4') {
        params.baseType = 8
      } else {
        params.baseType = 7
      }
      if (`${this.curItem}` !== '1') {
        userMyCollect(params).then(res => {
          this.load = false
          if (res.data.list.length < this.pageSize) {
            this.finished = true
          }
          this.list = this.list.concat(res.data.list)
          // 加载状态结束
          this.loading = false
          if (this.list.length <= 0) {
            this.isNone = true
          } else {
            this.isNone = false
          }
          this.pageNum++
        })
      } else {
        params.openId = this.userInfo.iepOpenId
        if (`${this.curItem}` === '1') {
          caseCollect(params).then(res => {
            this.load = false
            if (res.data.list.length < this.pageSize) {
              this.finished = true
            }
            this.list = this.list.concat(res.data.list)
            // 加载状态结束
            this.loading = false
            if (this.list.length <= 0) {
              this.isNone = true
            } else {
              this.isNone = false
            }
            this.pageNum++
          })
        } else if (`${this.curItem}` === '2') {
          docuCollect(params).then(res => {
            this.load = false
            if (res.data.list.length < this.pageSize) {
              this.finished = true
            }
            this.list = this.list.concat(res.data.list)
            // 加载状态结束
            this.loading = false
            if (this.list.length <= 0) {
              this.isNone = true
            } else {
              this.isNone = false
            }
            this.pageNum++
          })
        } else if (`${this.curItem}` === '3') {
          liveCollect(params).then(res => {
            this.load = false
            if (res.data.list.length < this.pageSize) {
              this.finished = true
            }
            this.list = this.list.concat(res.data.list)
            // 加载状态结束
            this.loading = false
            if (this.list.length <= 0) {
              this.isNone = true
            } else {
              this.isNone = false
            }
            this.pageNum++
          })
        }
      }
    },
    handleJump (item) {
      this.dataDetails = item
      if (`${item.isUnlock}` === '1' && !item.myUnlock && `${item.type}` === '2') {
        this.dataProps.baseId = item.id
        this.dataProps.unlockCost = item.unlockCost
        this.$refs.dialogUnlock.dailogShow = true
        return
      }
      this.handleGotoDetails()
    },
    async handleGotoDetails () {
      let item = this.dataDetails
      let openidBindli = `&unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(`xxbiep${this.userInfo.iepOpenId}`)}`
      window.sessionStorage.setItem('entrance', '59')
      let trackParams = `&entrance=59&businessChannel=59`
      if (`${this.curItem}` === '2') {
        this.$router.push({
          path: '/articleDetails',
          query: {
            id: item.id,
            entrance: '59',
            channel: '59'
          }
        })
      } else if (`${this.curItem}` === '1') {
        setTimeout(() => { traceClickURL() })
        window.location.href = `${process.env.bingliUrl}/wap/index.html#/casedetails?id=${item.id}${openidBindli}${trackParams}`
      } else if (`${this.curItem}` === '0') {
        const query = {
          courseId: item.id,
          entrance: '59',
          channel: '59'
        }
        const isscorm = await isScorm(item.id)
        let path = '/courserDetails'
        if (isscorm.data) {
          path = '/scormCourseDetail'
        }
        this.$router.push({path, query})
      } else if (`${this.curItem}` === '4') {
        if (item.baseType === 9) {
          // 课件文件收藏：跳 filePreview 预览页（baseType=9）
          this.$router.push({
            path: '/filePreview',
            query: {
              materialId: item.materialId || item.id,
              entrance: '59',
              channel: '59'
            }
          })
          return
        }
        this.$router.push({
          path: '/technologyDetail',
          query: {
            fileId: item.id,
            entrance: '59'
          }
        })
      } else {
        localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/liveDetails?liveId=${item.id}&entrance=59&channel=59`)
        this.$router.push({
          path: `/liveDetails`,
          query: {
            liveId: item.id,
            entrance: '59',
            channel: '59'
          }
        })
      }
    },
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.my-collect {
  background: #F9F8F7;
  min-height: 100vh;
  width: 100vw;
  .cons-flex {
    width: 100%;
    display: flex;
    align-items: center;
    height: 60px;
    position: fixed;
    top: 0px;
    z-index: 99;
    .cons-item {
      flex: 1;
      text-align: center;
      position: relative;
      font-size: 14px;
      color: #656E7F;
      font-weight: 500;
      position: relative;
      height: 42px;
      line-height: 42px;
      white-space: nowrap;
      .img-btm {
        width: 24px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 6px;
      }
      &.cur {
        color: #EB1700;
        font-weight: 600;
      }
    }
  }
  .cons-list {
    background-color: #fff;
    border-radius: 12px;
    position: relative;
    top: 60px;
    margin: 0 12px;
    padding: 15px 0;
    box-sizing: border-box;
  }
  .flex-con {
      display: flex;
      justify-content: space-between;
      padding: 0 12px;
      box-sizing: border-box;
      margin-bottom: 25px;

      .right-con {
        width: 110px;
        height: 60px;
        position: relative;
        border-radius: 5px;
        overflow: hidden;

        .con-cover {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .tag-txt {
          position: absolute;
          width: 30px;
          height: 16px;
          font-size: 10px;
          background-color: #6A7481;
          border-radius: 5px;
          left: 0;
          top: 0;
          text-align: center;
          line-height: 16px;
          color: #fff;
          font-size: 10px;
        }
      }

      .left-con {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .txt1 {
          flex: 1;
          font-size: 14px;
          color: #000000;
          font-weight: 500;
          line-height: 20px;
          max-height: 40px;
          margin-bottom: 8px;
          width: 180px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: inherit;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }

        .txt2 {
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: #B1B1B1;
          font-size: 12px;
          .span1 {
            width: 130px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
    .search-none {
      padding-bottom: 40px;
      box-sizing: border-box;
      .none-img {
        width: 185px;
        margin-left: 50%;
        transform: translateX(-50%);
        margin-top: 150px;
      }

      .none-txt {
        font-size: 12px;
        color: #949BA5;
        text-align: center;
        margin-top: 10px;
      }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/person/myCollect.vue